module.exports = __webpack_public_path__ + "img/coin.7eb04d15.jpg";